import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  border: 1px solid #ededed;
  background-color: #f6f6f6;
  height: 32px;
  border-radius: 2px;
  width: 100%;
  overflow: hidden;
`;

export const BackgroundHighlight = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #ffffff;
  height: 100%;
  transition: 0.3s left ease-out, 0.3s width ease-out;
`;

export const SwitchWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  z-index: 1;
`;

export const SwitchButton = styled.button`
  width: 100%;

  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;

  font-weight: bold;
  font-size: 18px;
  line-height: 24px;

  &.buy {
    color: #00ab6b;
  }

  &.sell {
    color: #ee4a49;
  }
`;
